import { render, staticRenderFns } from "./fccPermissoes.vue?vue&type=template&id=1220e09e"
import script from "./fccPermissoes.vue?vue&type=script&lang=js"
export * from "./fccPermissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports